//import { SSL_OP_EPHEMERAL_RSA } from 'constants'
import { http } from '../plugins/http'
import buffer from 'buffer';

// Tracks file-document requests (v1/files) that are currently in flight, keyed
// by their document id. Guards against duplicate submits when a user clicks a
// document/email action button multiple times before the first request returns
// (observed as the same material-order email being sent to suppliers 2-4 times).
// Module-level so the guard is shared across all component instances that reach
// openFileDocument via the global mixin.
const _openFileDocumentInFlight = new Set()

/* eslint-disable */
export default {
  // copy as reactive properties, thus they will remain same object
  copyProperties(to, from) {
    for (var property in from) {
      var descriptor = Object.getOwnPropertyDescriptor(from, property)

      if (
        descriptor &&
        (!descriptor.writable ||
          !descriptor.configurable ||
          !descriptor.enumerable ||
          descriptor.get ||
          descriptor.set)
      ) {
        Object.defineProperty(to, property, descriptor)
      } else {
        to[property] = from[property]
      }
    }

    return to
  },

  // copy as values, thus properties will be different objects
  copyValueProperties(to, from) {
    for (var prop in from) {
      if (from.hasOwnProperty(prop)) {
        // Vue.set(to, prop, from[prop])
        to[prop] = from[prop]
      }
    }

    return to
  },

  findMetadataColumnIds(metadataNode, skipPaths, currPath = '', columnIds = []) {
    if (typeof metadataNode !== "object" || metadataNode === null) 
      return columnIds;

    if(skipPaths && skipPaths.includes(currPath)) {
      //console.log('exit path match - ' + currPath)
      return columnIds;
    }

    for (const key in metadataNode) {
      if (key === "columns" && Array.isArray(metadataNode[key])) {
        metadataNode[key].forEach((column) => {
          if (column.id) {
            columnIds.push(column.id);
          } else if(Array.isArray(column)) {
            column.forEach((c) => {
              if (c.id) columnIds.push(c.id);
            });
          }
        });
      } else {
        const nextPath = currPath.length == 0 ? key : `${currPath}.${key}`;
        // console.log(nextPath);
        this.findMetadataColumnIds(metadataNode[key], skipPaths, nextPath, columnIds);
      }
    }

    return columnIds;
  },

  initializeMissingHierarchyValues(keys, object) {
    keys.forEach((key) => {
      const path = key.split('.');
      let current = object;

      for (let i = 0; i < path.length - 1; i++) {
        const part = path[i];
        if (!current[part])
          current[part] = {};

        current = current[part]; // Move to the next level
      }
    });
  },

  initializeMissingCustomValues(metadata, object, skipPaths) {
    var customValues = this.findMetadataColumnIds(metadata, skipPaths).filter(n => n.startsWith('values.') || n.startsWith('component.values.'));
    //console.log('metadata',metadata)
    //console.log('object',object)
    //console.log('customValues',customValues);
    this.initializeMissingHierarchyValues(customValues, object)
  },

  findHierObjectAndPropertyName(entity, path) {
    const dom = path.split('.')
    
    for (var y = 0; y < dom.length - 1; y++) {
      if(!entity)
        break;

      entity = entity[dom[y]]
    }

    var propName = dom.length >= 1 ? dom[y] : ''

    return { entity: entity, propName: propName }
  },

  openFileDocument(id, dontShowPrint) {
    // Drop the call if an identical document request is already in flight. This
    // stops double-clicks on document/email action buttons from firing the same
    // v1/files request (and, for action=Email, sending the supplier email) twice.
    if (_openFileDocumentInFlight.has(id)) {
      return Promise.resolve()
    }
    _openFileDocumentInFlight.add(id)

    return http
      .get(`v1/files/${id}`)
      .then((response) => {
        if (response.data.contentType == 'text/html') {
          var newWindow = window.open();
          newWindow.opener = null;
          newWindow.document.write(response.data.contents);
          newWindow.document.close();
          if (!dontShowPrint) {
            // chrome renders the images with delay
            setTimeout(function () {
              newWindow.print();
              newWindow.close();
            }, 500);
          }
        } else if (
          !response.data.contentType || response.data.contentType.startsWith('image/') || response.data.contentType.startsWith('text/')
        ) {
          this.openFileDocumentNew(response.data.contentType, response.data.name, response.data.contents);
        } else {
          // download
          const a = document.createElement('a');
          a.href = `data:${response.data.contentType};base64,` + response.data.contents;
          a.download = response.data.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((error) => {
        this.showApiError(error)
      })
      .finally(() => {
        _openFileDocumentInFlight.delete(id)
      })
  },

  openFileDocumentNew(contentType, name, contents) {
    const byteArray = buffer.Buffer.from(contents, 'base64')

    var file = new Blob([byteArray], { type: contentType })
    var fileURL = URL.createObjectURL(file)
    window.open(fileURL, name)

    setTimeout(() => {
      try {
        URL.revokeObjectURL(fileURL)
      } catch (e) {}
    }, 180000)
  },

  showApiError(error) {
    // console.error(error)
    this.$swal('Error', error.response.data.error.message, 'error')
  },

  decodeBase64(str) {
    var contents = str
    for (var i = 0; i < 2; i++) {
      var idx = contents.indexOf('/')
      contents = contents.substring(idx + 1)
    }

    var result = decodeURIComponent(
      atob(contents)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return result
  },

  buildUrl(baseUri, searchOptions, customerId, componentId, orderId) {
    var query = ''
    var hasParams = baseUri && baseUri.indexOf('?') > 0

    if (customerId && 1 * customerId > 0) {
      query += '?customerId=' + customerId
    }

    if (componentId && 1 * componentId > 0) {
      query += (query.length > 0 ? '&' : '?') + `componentId=${componentId}`
    }

    if (orderId && 1 * orderId > 0) {
      query += (query.length > 0 ? '&' : '?') + `orderId=${orderId}`
    }

    if (searchOptions) {
      if (searchOptions.searchText) {
        // Encoded because this is free text typed by the user - an unescaped '&', '#' or '+'
        // would otherwise truncate or corrupt the query string.
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `searchText=${encodeURIComponent(searchOptions.searchText)}`
      }
      if (searchOptions.options) {
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `options=${searchOptions.options.join(',')}`
      }
      if (searchOptions.dateRange) {
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `dateFrom=${this.getDateValue(searchOptions.dateRange[0])}`
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `dateTo=${this.getDateValue(searchOptions.dateRange[1])}`
      }
      if (searchOptions.mode) {
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `mode=${searchOptions.mode}`
      }
      if (searchOptions.offset) {
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `offset=${searchOptions.offset}`
      }
      if (searchOptions.limit) {
        query +=
          (query.length > 0 || hasParams ? '&' : '?') +
          `limit=${searchOptions.limit}`
      }
    }

    return baseUri + query
  },

  /*
  getDateValue(src) {
    try {
      return src ? src.toISOString().split('T')[0] : null
    } catch (ex) {
      return null
    }
  },*/
  getDateValue(src) {
    try {
      if (!src) return null;
  
      const d = new Date(src); // Ensure it's a Date object
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(d.getDate()).padStart(2, "0");
  
      return `${year}-${month}-${day}`; // Keeps it in local time
    } catch (ex) {
      return null;
    }
  },

  isOrderMatchesFilter(order, searchText) {
      if (order) {
        if ( this.anyValueMatches(
              [order.id, order.externalRefId, order.customerName],
              searchText)) {
          return true
        }

        if (order.items && order.items.length > 0) {
          for (var i = 0; i < order.items.length; i++) {
            const item = order.items[i]
            if (item.component
              && this.anyValueMatches(
                  [item.component.externalRefId, item.component.name],
                  searchText )) {
                  return true;
                }
          }
        }
      }

      return false
  },

  anyValueMatches(values, searchText) {
      for (var i = 0; i < values.length; i++) {
        if (values[i]) {
          if (`${values[i]}`.toLowerCase().indexOf(searchText) >= 0) {
            return true
          }
        }
      }
      return false
    },
}
